import { useQuery, keepPreviousData } from '@tanstack/react-query';

import {
  getMarketingConsents,
  type MarketingConsentFilters,
} from '../services/marketing-consent.service';

export function useMarketingConsents(page: number, filters: MarketingConsentFilters = {}) {
  return useQuery({
    queryKey: ['marketing-consents', page, filters.q ?? null, filters.role ?? null],
    queryFn: () => getMarketingConsents(page, filters),
    placeholderData: keepPreviousData,
  });
}
